module.exports = __webpack_public_path__ + "img/content_m.492d91c1.png";